import { combineReducers } from 'redux';

import forgotPasswordOptionsReducer from './forgotPasswordOptionsReducer';
import forgotPasswordOtpReducer from './forgotPasswordOtpReducer';
import forgotPasswordEmailReducer from './forgotPasswordEmailReducer';
import saveUnknownUserDataReducer from './saveUnknownUserDataReducer';
import forgotPasswordChangeReducer from './forgotPasswordChangeReducer';

export default combineReducers({
  options: forgotPasswordOptionsReducer,
  otp: forgotPasswordOtpReducer,
  mail: forgotPasswordEmailReducer,
  user: saveUnknownUserDataReducer,
  change: forgotPasswordChangeReducer
});
